import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Sidebar } from '../components';
import { Role } from '../models';
import { AdminLink, AppAdminLink, FrontOfficeLink } from '../models/Routes';
import { AdminFoodTypes, AdminReports, AdminStoreAndDepartment, DepartmentSelect } from '../scenes';
import RolesGuard from '../scenes/admin/components/RolesGuard';
import UserManagement from '../scenes/admin/components/UserManagement';

const AppAdminLayout = () => {
  return (
    <RolesGuard requiredRole={Role.APP_ADMIN}>
      <div className='sidebar-layout'>
        <Sidebar role={Role.APP_ADMIN} />
        <div className='main-container'>
          <Switch>
            {/* TODO remove admin link routes once customer has started using the app admin routes */}
            <Route path={AdminLink.REPORTS} component={AdminReports} />
            <Route path={AdminLink.STORES} component={AdminStoreAndDepartment} />
            <Route path={AdminLink.USERS} component={UserManagement} />
            <Route path={AdminLink.FOOD_TYPES} component={AdminFoodTypes} />
            <Route path={AppAdminLink.REPORTS} component={AdminReports} />
            <Route path={AppAdminLink.STORES} component={AdminStoreAndDepartment} />
            <Route path={AppAdminLink.USERS} component={UserManagement} />
            <Route path={AppAdminLink.FOOD_TYPES} component={AdminFoodTypes} />
            <Route path={FrontOfficeLink.DEPARTMENT_SELECT} component={DepartmentSelect} />{' '}
            {/* TODO replace with FrontOfficeLink */}
            <Redirect to={AppAdminLink.FOOD_TYPES} />
          </Switch>
        </div>
      </div>
    </RolesGuard>
  );
};

export default AppAdminLayout;
